/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATEAWARD= createAsyncThunk(
  "updateAward/updateAward",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateAwardSlice = createSlice({
  name: "updateAwardSlice",
  initialState: {
    updateAward: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateAward: (state) => {
        state.updateAward.loading = false
        state.updateAward.error = false
        state.updateAward.data = []
        state.updateAward.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEAWARD.fulfilled, (state, action) => {
      state.updateAward = {
        ...state.updateAward,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEAWARD.pending, (state, action) => {
      state.updateAward = {
        ...state.updateAward,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEAWARD.rejected, (state, action) => {
      state.updateAward = {
        ...state.updateAward,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateAwardAction = {
    UPDATEAWARD,
};

export { updateAwardAction };
export default updateAwardSlice.reducer;
export const {setInitialStateOfupdateAward} = updateAwardSlice.actions